let GoldMatchGetTimesPanel = xClass("GoldMatchGetTimesPanel", BasePanel, () => {
    return cc.CSLoader.createNode("cocos/gold_carnival_get_count_panel.csb")
})
GoldMatchGetTimesPanel.resources = [
    "font/zzgftongxin_40_aquastroke.fnt",
    "font/zzgftongxin_40_greenstroke.fnt",
    "cocos/gold_carnival_get_count.plist",
    "cocos/gold_carnival_get_count_btn_buy.csb",
    "cocos/gold_carnival_get_count_buy_item.csb",
    "cocos/gold_carnival_get_count_help_item.csb",
    "cocos/gold_carnival_get_count_panel.csb",
    "cocos/gold_carnival_get_count_btn_help.csb"
]
let GoldMatchGetTimesPanelEvent = {
    Close: "GOLDMATCHGETTIMESPANELEVENT.CLOSE",
    Buy: "GOLDMATCHGETTIMESPANELEVENT.BUY",
    ShareMessage: "GOLDMATCHGETTIMESPANELEVENT.SHAREMESSAGE",
}
GoldMatchGetTimesPanel.load = function () {
    return new Promise((resolve, reject) => {
        preloadWithLoading(GoldMatchGetTimesPanel.resources, resolve, reject, reject)
    })
}
GoldMatchGetTimesPanel.prototype.ctor = function () {
    let self = this
    BasePanel.prototype.ctor.call(self)

    self.dcSession = null;  // 人民币购买项显示session
    self.initUI()
}
GoldMatchGetTimesPanel.prototype.initUI = function () {
    let self = this
    self.closeBtn = self.getChildByName("btn_close")
    quickBuildUIBUtton(self.closeBtn, function () {
        self.onClose()
        self.dispatchEvent({name: GoldMatchGetTimesPanelEvent.Close})
    })

    self.buyItem = self.getChildByName("buy_item")
    self.helpItem = self.getChildByName("help_item")

    
    var noShare = !SnsProxy.getInstance().allowShare()
    if (!noShare && window.mini && mini.getPlatform() == MiniPlatform.tt && !SnsProxy.getInstance().curVerCanShare())
        noShare = true;
    if (noShare){
        self.helpItem.setVisible(false);
        self.buyItem.x += 135;
    }

    let buyTips = self.buyItem.getChildByName("text")
    buyTips.x = 47
    buyTips.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    let helpTips = self.helpItem.getChildByName("text")
    helpTips.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    helpTips.setString("新用户帮助+1次")

    self.buyBtn = self.buyItem.getChildByName("btn")
    self.buyBtn.getChildByName("label").getVirtualRenderer().setAdditionalKerning(-4)
    quickBuildUIGLabelButton(self.buyBtn, () => {
        let productMate = GoldMatchActivityManager.getInstance().getCurrentProductInfo()
        DCAssist.dc4User101("goldMode", "click_rmb_buy_icon", {
            money: productMate && productMate.price || 1
        })
        self.dispatchEvent({name: GoldMatchGetTimesPanelEvent.Buy, dcSession: self.dcSession})
    })
    
    self.shareBtn = self.helpItem.getChildByName("btn")
    quickBuildUIGLabelButton(self.shareBtn, () => {
        self.dispatchEvent({name: GoldMatchGetTimesPanelEvent.ShareMessage})
    })
    self.shareBtn.setString(getText("goldmatch.activity.askfor.time"))
    DCAssist.dc4ShareShow("GoldMatchAskHelp");
    self.updateUI()
}
GoldMatchGetTimesPanel.prototype.updateUI = function () {
    let self = this
    let platform = SnsProxy.getInstance().getSystemPlatfrom()
    
    let bg = self.getChildByName("bg")
    let bgSize = bg.getContentSize()
    if (platform === SystemPlatform.IOS && !UserManager.getInstance().canIosToMiniPay()) {
        self.buyItem.setVisible(false)
        self.helpItem.x = bg.x + (bgSize.width - self.helpItem.getContentSize().width) / 2
        let helpBg = self.helpItem.getChildByName("bg")
        let helpBgSize = helpBg.getContentSize()
        let newWidth = bgSize.width * 0.8
        helpBg.setContentSize(newWidth, helpBgSize.height)
        helpBg.x += (helpBgSize.width - newWidth) / 2
    }else {
        self.buyBtn.setString(`￥ 1.00`)
        let productInfo = GoldMatchActivityManager.getInstance().getCurrentProductInfo()
        if(productInfo) {
            self.buyBtn.setString(`￥ ${productInfo.price}.00`)
            self.dcSession = DCAssist.dc4ShowCashGoods("gold_mode", "else", [productInfo.goodsId])
        }
    }
}
GoldMatchGetTimesPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this)
    ResManager.release(GoldMatchGetTimesPanel.resources)
}

module.exports = [GoldMatchGetTimesPanel, GoldMatchGetTimesPanelEvent]